import React, { useState } from "react";

import { IconEye, IconUserCircle } from '@tabler/icons-react';

import { Text } from '@mantine/core';
import { Tooltip } from '@mantine/core';

const OtherUser = ({ isMobile, other, open, socketId, update, onWatchClick, uiTheme }) => {

// const {isOtherPreviewOpen, setIsOtherPreviewOpen} = useObjectStore()

const [hover, setHover] = useState(false)

// console.log(other)
const handleWatchClick = () => {
  onWatchClick?.(socketId);
}

// NEED TO MOVE PREVIEW ELSEWHERE SO IT CAN STAY OPEN WHEN USER CHANGES TABS

 
  return (
    <div style={{ width: "auto", minHeight: 22, display: "grid", gridTemplateColumns: "10fr 2fr", alignItems: "center" }}>
        <div>
          <Text
            fw={400}
            size='xs'
            c={uiTheme?.rowText || "#364153"}
            style={{
            }}
          >
            <IconUserCircle size={18} style={{ marginRight: 2 }} />
            {update.cursor && update.cursor.name} {update.preview && update.preview.name}
            {` | `}
            {update.cursor && update.cursor.artboard}
            {update.preview && update.preview.artboard}
          </Text>
        </div>
        <div>
          {update.preview && (
            <Text
              fw={400}
              size="xs"
              c={!hover ? (uiTheme?.eye || "#424242") : (uiTheme?.eyeHover || "#868e96")}
              onPointerOver={() => setHover(true)}
              onPointerLeave={() => setHover(false)}
              style={{ marginLeft: 10 }}
            >
              <Tooltip label="See user view">
                <IconEye
                  size={18}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleWatchClick()}
                />
              </Tooltip>
            </Text>
          )}
        </div>
    </div>
  )
}

      export default OtherUser